module.exports = __webpack_public_path__ + "assets/images/2f0eaca10a73f10e08f69a4174da0ab5.svg";